import React from 'react';
import './EventsHeader.scss';
import { Icon } from 'antd';
import { ICategory } from 'Components/MenuMain/MenuMainContent';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
	isMobile: boolean;
	isBoxView: boolean;
  isSearchResult: boolean;
	isShowingMobileFilter: boolean;
	category: ICategory;
	onSetBoxView: () => void;
	onSetListView: () => void;
	onToggleMobileFilter: () => void;
}

const EventsHeader: React.SFC<IProps> = ({
	isMobile,
	isBoxView,
	isSearchResult,
	isShowingMobileFilter,
	category,
	onSetBoxView,
	onSetListView,
	onToggleMobileFilter,
}) => {

	const HeaderText = () => (
		isSearchResult ?
			<FormattedText
				style='title'
				displayName='Sökresultat'
				formattedName='event.searchresult'
			/> :
			<FormattedText
				style='title'
				displayName={ category.displayName }
				formattedName={ category.formattedName }
			/>
	);

	if (isMobile) {
		return (
			<WrapperLayout style='events-header mobile' justify='center'>
				<HeaderText />
				{ !isSearchResult && 
					<Icon 
						className='toggle-icon' 
						type={ isShowingMobileFilter ? 'caret-up' : 'caret-down' } 
						onClick={ onToggleMobileFilter } 
					/> 
				}
			</WrapperLayout>
		);
	}

  return (
		<WrapperLayout 
			style='events-header' 
			align='middle' 
			justify='space-between' 
			padding='md'
		>
			<HeaderText />
			<div>
				<button onClick={ onSetListView } className={ !isBoxView ? 'active' : '' }>
					<Icon type='bars' />
				</button>
				<button onClick={ onSetBoxView } className={ isBoxView ? 'active' : '' }>
					<Icon type='appstore' />
				</button>
			</div>
		</WrapperLayout>
  );
};

export default EventsHeader;


// WEBPACK FOOTER //
// ./src/pages/EventsPage/EventsHeader/EventsHeader.tsx